import cloneDeep from "lodash/cloneDeep";
import isString from "lodash/isString";
import D from "debug";

const debug = D("ciris:formMixin");

export default {
  data,
  methods: {
    cancelar,
    editar,
    guardar,
    siguiente,
  },
  created() {
    this.editando = this.$router.currentRoute.params.edit;
    this.tabActual = this.copia.bloqueActual || 0;
  },
  mounted() {
    document.querySelector(".tabs").scrollLeft = 105 * this.tabActual;
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    window.copiaFotos = null;
    this.$store.commit(this.$actions.resetFormulario);
  },
};

function cancelar() {
  const clonFormulario = cloneDeep(this.formulario);
  this.copia = window.copiaFotos
    ? {
      ...clonFormulario,
      ...window.copiaFotos,
    }
    : clonFormulario;
  this.editando = false;
}

function data() {
  return {
    tabActual: 0,
    copia: null,
    submitted: false,
    editando: false,
  };
}

function editar() {
  window.copiaFotos = cloneDeep({
    registroFotografico: this.copia.registroFotografico,
    fotosPaisajeFinca: this.copia.fotosPaisajeFinca,
    fotosAnimalComido: this.copia.fotosAnimalComido,
  });
  this.editando = true;
}

function guardar(form) {
  this.submitted = true;
  const bloqueActual = `bloque${this.tabActual + 1}`;
  return this.$refs[bloqueActual].validar().then((valido) => {
    if (valido) {
      if (form.sinAdjuntos) {
        const temp = cloneDeep(form);
        // borra imagenes por si cargaron algo antes de darle "no adjuntar nada"
        temp.registroFotografico = [];
        temp.fotosPaisajeFinca = [];
        temp.fotosAnimalComido = [];
        return enviarSinImgs.call(this, temp);
      }
      if (form.fotosPaisajeFinca.length && form.fotosAnimalComido.length) {
        // si es string es porque el usuario no ha abierto el bloque de fotos
        if (isString(form.fotosPaisajeFinca[0])) {
          return enviarSinImgs.call(this, form);
        }
        return enviarConImgs.call(this, form);
      }
      return this.$toastr("error", "Faltan imágenes adjuntas en los campos requeridos", "Error");
    }
    return false;
  });
}

function enviarSinImgs(form) {
  this.enviando = true;
  const temp = cloneDeep(form);
  temp.tipoDepredador = form.body.tipoDepredador;
  temp.estado = "nuevo";
  this.$store.commit(this.$actions.showModal, {
    componentName: "cargandoModal",
    params: { grande: true },
  });
  return this.$store
    .dispatch(this.$actions.guardarFormulario, { formulario: temp, actualizarLista: true })
    .then((resp) => {
      this.$toastr("success", "Formulario enviado exitosamente", "Éxito");
      this.$router.push({ name: "formularios" });
      return resp;
    })
    .finally(() => {
      this.enviando = false;
      this.$store.commit(this.$actions.hideModal);
    });
}

function enviarConImgs(form) {
  const self = this;
  const subir = (fotos) => {
    // quitar img de las que tienen id pues no tiene sentido volverlo a enviar
    // pero si enviar el comentario de la foto por si lo cambiaron
    const fotosTemp = fotos.map((foto) => {
      if (foto._id) delete foto.img;
      return foto;
    });
    return self.$store.dispatch(self.$actions.postImagen, fotosTemp);
  };
  const promsRF = subir(form.registroFotografico);
  const promsPF = subir(form.fotosPaisajeFinca);
  const promsAC = subir(form.fotosAnimalComido);
  self.enviando = true;
  self.$store.commit(this.$actions.showModal, {
    componentName: "cargandoModal",
    params: { grande: true },
  });
  return Promise.all([promsRF, promsPF, promsAC])
    .then((resul) => {
      debug("Imagenes subidas", resul);
      const temp = cloneDeep(form);
      temp.registroFotografico = resul["0"].data;
      temp.fotosPaisajeFinca = resul["1"].data;
      temp.fotosAnimalComido = resul["2"].data;
      temp.tipoDepredador = form.body.tipoDepredador;
      temp.estado = "nuevo";
      return temp;
    })
    .then(formConImgs => self.$store.dispatch(self.$actions.guardarFormulario, {
      formulario: formConImgs,
      actualizarLista: true,
    }))
    .then(() => {
      self.$toastr("success", "Formulario enviado exitosamente", "Éxito");
      return self.$router.push({ name: "formularios" });
    })
    .finally(() => {
      self.enviando = false;
      self.$store.commit(this.$actions.hideModal);
    });
}

function siguiente(borrador) {
  this.submitted = true;
  return this.$refs[`bloque${this.tabActual + 1}`].validar()
    .then((valido) => {
      if (valido) {
        this.submitted = false;
        this.tabActual += 1;
        window.scrollTo(0, 0);
        document.querySelector(".tabs").scrollLeft += 105;
        if (borrador.bloqueActual < this.tabActual) {
          borrador.bloqueActual = this.tabActual;
        }
        const { index } = this.$router.currentRoute.params;
        return this.$store.commit(this.$actions.actualizarBorradores, { borrador, index });
      }
      return this.$toastr("error", "Hay campos requeridos sin completar", "Error");
    });
}
